var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "popup-accordion" }, [
    _vm.$root.states.popupAccordionData
      ? _c("div", { staticClass: "popup" }, [
          _c(
            "div",
            { staticClass: "accordion-menu" },
            [
              _vm._l(
                _vm.$root.states.popupAccordionData["content_list_repeater"],
                function(listItem, listItemIndex) {
                  return [
                    _vm._l(listItem["list_content_composer"], function(
                      listContent,
                      listContentIndex
                    ) {
                      return [
                        listContent["acf_fc_layout"] ===
                        "list_content_composer_subline_h2"
                          ? _c(
                              "div",
                              {
                                staticClass: "accordion-menu-item",
                                on: {
                                  click: function($event) {
                                    return _vm.scrollToAccordionIndex(
                                      listItemIndex,
                                      listContentIndex
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      listContent["list_content_subline_h2"]
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ]
                }
              )
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81330b92", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81330b92","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/PopupAccordion.vue
// module id = 548
// module chunks = 0